import React from "react";
import { StyleSheet, View } from "react-native";
import VideoPlayer from "@components/VideoPlayer";
import Button from "@components/Button";
import useGetVideoTime from "../../utils/useGetVideoTime";

const VideoContainer = ({
  video_link = "",
  handleCta = () => {},
  ctaText = "Close",
  onEnd = () => {},
  resumedEventTrack = () => {},
  pausedEventTrack = () => {},
}) => {
  const [state] = useGetVideoTime();

  return (
    <>
      <VideoPlayer
        videoLink={video_link}
        onEnd={onEnd}
        resumedEventTrack={resumedEventTrack}
        pausedEventTrack={pausedEventTrack}
      />
      {state.isCompleted && (
        <View style={styles.videoStateCompleteContainer}>
          <Button
            style={styles.paddingEvenly}
            buttonWidth="100%"
            btnText={ctaText}
            buttonFontType="head1"
            height={56}
            borderRadius={10}
            onPress={handleCta}
          />
        </View>
      )}
    </>
  );
};

const styles = StyleSheet.create({});

export default VideoContainer;
